<div class=" row mt-4 right-section file-inspiration">
  <div class="col-md-12 mt-5 text-center p-5" style="background-color: #fff;" *ngIf="inspirationList.length <= 0">
    <img src="../../../assets/img/nothing.png" /> 
  </div>
  <div class="col-md-12 mt-5 text-center p-5" style="background-color: #fff;" *ngIf="inspirationList.length !== 0">
    <div class="row">
    <div class="col-md-4 mt-4"  *ngFor="let obj of inspirationList; let i = index;">
      <div class="card sadowcard" style="display: inline-block;">
        <!-- Card image -->
        <div class="view overlay">
          <a *ngIf="obj.file_info.content_type == 'image/png'" href="{{obj.file_info.url}}" target="_blank" ><img  style="height: 100px;width: 200px;cursor: pointer;"  src="{{obj.file_info.url}}"  /></a>
          <a *ngIf="obj.file_info.content_type == 'application/pdf'" href="{{obj.file_info.url}}" target="_blank">  <img  style="height: 100px;cursor: pointer;"  src="./assets/img/no_image.svg"  /></a>
        <a *ngIf="obj.file_info.content_type == 'application/msword'" href="{{obj.file_info.url}}" target="_blank"> <img  style="height: 100px;cursor: pointer;"  src="./assets/img/6818351_preview.png"  /></a>
          <a *ngIf="obj.file_info.content_type == 'application/x-ole-storage'" href="{{obj.file_info.url}}" target="_blank"> <img  style="height: 100px;cursor: pointer;"   src="./assets/img/download.jpeg"  /></a>
           
          <a>
            <div class="mask rgba-white-slight"></div>
          </a>
        </div>
        <!-- Card content -->
        <div class="card-body">
          <!-- Title -->
          <p class="mb-0 mt-2" style="font-size:13px;">
          
            <span>File Name:</span><span style="color: #7E7E7E;">{{obj.file_info.file_name}}</span>
          </p>
         
        </div>
      </div>
    </div>
    </div>
  </div>
</div>

<div class="modal fade" id="exampleModalLong2" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle" aria-hidden="true">
  <div class="modal-dialog" role="document" style="max-width: 90%;min-height: 500px;">
    <div class="modal-content modal-bg" style="height: 800px;padding-bottom: 40px;">
      <div class="modal-header">
       
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" style="position: absolute;left:97%">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body" style="padding-bottom: 40px;">
       <img src="{{imgfile}}" style="height: 600px;width: 100%;">
      
      </div>
      <div class="modal-footer">
        <button style="margin-left: 80%;" type="button" class="btn btn-pink" data-dismiss="modal">Cancel</button>
     
      </div>
      
    </div>
  </div>
</div>
<div class="modal fade" id="exampleModalLong3" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle" aria-hidden="true">
  <div class="modal-dialog" role="document" style="max-width: 30%;min-height: 500px;">
    <div class="modal-content modal-bg" style="height: 400px;padding-bottom: 40px;">
      <div class="modal-header">
       
        <button  type="button" class="close" data-dismiss="modal" aria-label="Close" style="position: absolute;left:95%">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body" style="padding-bottom: 40px;">
        <img src="./assets/img/no_image.svg" style="width: 100%;height: 200px;">

       
      </div>
      <div class="modal-footer">
        <a target="_blank" href="{{imgfile}}" style="position: relative;left: -41%;;"  class="btn btn-pink" >View PDF</a>
       
        
        <button style="position: relative;left: -18%;" type="button" class="btn btn-pink" data-dismiss="modal">Cancel</button>
      </div>
    </div>
  </div>
</div>




// WEBPACK FOOTER //
// ./src/app/platform/lead/inspiration-board/inspiration-board.component.html